import { apiWrapper } from "@/services/api";
import store from "@/store";

export const postEbusTentativeReservation = async (apiParams) => {
  console.log("postEbusTentativeReservation apiParams :>> ", apiParams);
  let response;
  try {
    response = await apiWrapper(
      "POST",
      `/reservations/tentative`,
      apiParams,
      false,
      false,
      "E-BUS"
    );
    console.log(
      "postEbusTentativeReservation response.data :>> ",
      response.data
    );
    store.commit("demand/setTentativeReservation", response.data);
  } catch (err) {
    console.log('ERROR"" postEbusTentativeReservation():', err);
    throw err;
  }
  return response.data;
};
